export enum StatusPillEnum {
  NotApplicable = "N/A",
  NotStarted = "Not Started",
  InProgress = "In Progress",
  Complete = "Complete",
}
